module.exports = __webpack_public_path__ + "img/star.a68f20b5.png";